import React from "react";
import Accordion from "component/Accordion/Accordion";

import {
  FaBuilding,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt
} from "react-icons/fa";
import "./Contact.scss";

const Contact = () => {
  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1>Get in Touch</h1>
        <p className="section-tagline">
          We are here to help and answer any questions you might have.
        </p>
      </div>

      <div className="contact-content">
        <div className="company-info">
          <div className="info-item">
            <FaBuilding className="icon" />
            <div>
              <h3>Company Information</h3>
              <p className="brand-name">Brand Name : NeoSapien</p>
              <p className="legal-name">
                Legal Entity Name : ZENITHZEPHYR WELLNESS PRIVATE LIMITED
              </p>
            </div>
          </div>

          <div className="contact-details">
            <div className="detail-row">
              <div className="info-item">
                <FaEnvelope className="icon" />
                <div>
                  <h4>Email</h4>
                  <a href="mailto:support@neosapien.xyz">
                    support@neosapien.xyz
                  </a>
                </div>
              </div>

              <div className="info-item">
                <FaPhoneAlt className="icon" />
                <div>
                  <h4>Phone</h4>
                  <a href="tel:+918045680341">080-456-80341</a>
                </div>
              </div>
            </div>

            <div className="info-item">
              <FaMapMarkerAlt className="icon" />
              <div>
                <h4>Business Address</h4>
                <address>
                  ScalerInnovation Lab,
                  <br />
                  Scaler School of Technology,
                  <br />
                  Parappana Agrahar, Electronic City Road,
                  <br />
                  Phase 1, Bengaluru, Karnataka - 560100
                </address>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Accordion />
    </div>
  );
};

export default Contact;
